import progress from 'nprogress'
import omit from 'lodash/omit'
import shuffle from 'lodash/shuffle'
import mapbox from 'mapbox-gl'
import { db } from '@/core/shared'

export const getters = {
    itemsFiltered: 'map/itemsFiltered'
}
export const mutations = {
    setCouponOnly: 'map/setCouponOnly',
    setCurrentSlide: 'map/setCurrentSlide',
    setItems: 'map/setItems'
}
export const actions = {
    setCouponOnly: 'map/setCouponOnly',
    setCurrentSlide: 'map/setCurrentSlide',
    fetchItems: 'map/fetchItems'
}

export const store = {
    state: {
        couponOnly: false,
        currentSlide: 0,
        items: []
    },
    getters: {
        [getters.itemsFiltered]: (state) => {
            return state.couponOnly
                ? state.items.filter(x => x.couponDiscount)
                : state.items
        }
    },
    mutations: {
        [mutations.setCouponOnly]: (state, payload) => {
            state.couponOnly = payload
        },
        [mutations.setCurrentSlide]: (state, payload) => {
            state.currentSlide = payload
        },
        [mutations.setItems]: (state, payload) => {
            state.items = payload
        }
    },
    actions: {
        [actions.setCouponOnly]: (context, payload) => {
            context.commit(mutations.setCouponOnly, payload)
        },
        [actions.setCurrentSlide]: (context, payload) => {
            context.commit(mutations.setCurrentSlide, payload)
        },
        [actions.fetchItems]: async (context) => {
            if (context.state.items.length) {
                return
            }
            progress.start()
            const res = await db.collection('spots').get()
            const spots = res.docs.map(x => ({
                id: x.id,
                coords: new mapbox.LngLat(x.data().coords.longitude, x.data().coords.latitude),
                ...omit(x.data(), 'coords')
            }))
            progress.done()
            context.commit(mutations.setItems, shuffle(spots))
        }
    }
}